<template>
    <div class="ether">
        <ul>
            <li>ROR'</li>
            <li>unpolar</li>
        </ul>
        <img
            src="@/assets/img/stoffe/ether/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Ether"
            title="Allgemeine Struktur der Ether"
        />
    </div>
</template>

<script>
export default {
    name: 'ether',
};
</script>
